export const CHARGE_VALUE = -150 * 15; // sets value for repelling of the primary categories
export const MAXIMUM_PRIMARY_RADIUS = 300; // maximum radius for primary categories
export const MAXIMUM_SECONDARY_RADIUS = 600; // maximum radius for secondary categories
export const MINIMUM_PERCENT = 0.01; // hide nodes that are less than this percent value
export const PRIMARY_INNER_SIZE = 40; // core size of the primary categories
export const SECONDARY_INNER_SIZE = 10; // core size of the secondary categories
export const PRIMARY_FONT_SIZE = '12px';